// extracted by mini-css-extract-plugin
export var authorAvatarContainer = "X_cT";
export var authorInfoContainer = "X_cV";
export var authorInfoDetails = "X_cW";
export var authorInfoSection = "X_cX";
export var authorSocialLinks = "X_cZ";
export var authorTooltipContainer = "X_c0";
export var authorTooltipContent = "X_cS";
export var authorTooltipLink = "X_cY";
export var authorTooltipZIndex = "X_c1";